import { MeterType } from "@next-platform/packages-ts-types";
/** HUD meter value: the snapshot value, else the meter floor. Dice floor to 0 so an unrolled die shows the dash. */
const resolveHudMeterValue = ({ meter, hudMeter }) => {
    if (hudMeter !== undefined && hudMeter !== null) {
        return hudMeter.value;
    }
    if (meter.type === MeterType.DICE) {
        return 0;
    }
    return meter.min ?? 0;
};
export default resolveHudMeterValue;
